import { mixins, styled } from '@bob/library'

interface CurvedConnectorWrapperProps {
  lineDirection: 'up' | 'down'
}

export const CurvedConnectorWrapper = styled.div<CurvedConnectorWrapperProps>`
  position: relative;
  display: inline-block;
  left: 50%;
  ${({ lineDirection }: CurvedConnectorWrapperProps) =>
    lineDirection === 'up' ? `transform: translateX(-100%);` : `transform: rotate(180deg);`}
  ${mixins.media.max.desktop} {
    display: none;
  }

  & svg {
    ${({ lineDirection }: CurvedConnectorWrapperProps) =>
      lineDirection === 'up' ? 'vertical-align: bottom;' : 'display: block;'}
  }
`

export const StraightConnectorWrapper = styled.div`
  position: relative;
  display: inline-block;
  left: 50%;
  transform: translateX(-50%);
  ${mixins.media.min.desktop} {
    display: none;
  }
`

export const DottedLine = styled.div`
  height: 50px;
  border-right: 4px dotted #d9d9d9;
`
